import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { Button } from '@blade/ui-kit'
import { CurrencyNetworkIcon } from '@root/entities/currency/ui'
import { selectedNetworkAtom } from '@root/entities/network'
import { walletsModelAtom } from '@root/entities/wallet'
import { AmountFormatted } from '@root/shared/core/format/numeric-presets-components'
import { useTranslation } from '@root/shared/localization'
import { ChevronUpDownGroupIcon, WalletOutlineIcon } from '@root/shared/ui-kit'

export const NotificationWidgetWalletsColumn = () => {
  const { t } = useTranslation()

  const [walletsModel] = useAtom(walletsModelAtom)
  const [network] = useAtom(selectedNetworkAtom)
  const [balance] = useAtom(walletsModel.nativeAssetBalance)
  const [wallets] = useAtom(walletsModel.wallets)

  return (
    <Heading>
      <Title>
        <Label>{t('common.balance')}</Label>
        <WalletsHeading>
          <WalletOutlineIcon size={22} color="var(--text-9)" />
          <WalletsHeadingCounter>
            {wallets.length}
            <hr />
            <AmountFormatted amount={balance} roundingMode="trunc" />
          </WalletsHeadingCounter>

          <CurrencyNetworkIcon network={network} size={18} />
        </WalletsHeading>
      </Title>
      <SettingsButton
        variant="ghost"
        size="h28"
        iconLeft={<ChevronUpDownGroupIcon />}
        radius="rounded"
      />
    </Heading>
  )
}

const Heading = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 4px;
  padding: 8px;
  padding-inline-start: 12px;
  align-items: start;
`

const Title = styled.div`
  display: grid;
  padding-top: 5px;
`

const WalletsHeading = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  align-items: center;
  gap: 6px;
  justify-items: start;
  justify-content: start;
`

const WalletsHeadingCounter = styled(Typography).attrs({
  variant: 'body1-semi-bold',
  component: 'span',
})`
  color: var(--text-12);

  display: grid;
  grid-template-columns: auto auto auto;
  align-items: center;
  justify-content: start;
  justify-items: start;
  gap: 7px;

  hr {
    border: none;
    width: 1px;
    height: 14px;

    border-radius: 2px;
    background: #424242;
  }
`

const Label = styled(Typography).attrs({
  variant: 'body3-medium',
  component: 'span',
})`
  color: var(--text-9);
`

const SettingsButton = styled(Button)`
  svg {
    color: var(--text-10);
  }
`
